/** ============================================================================
 * login
 *
 * @version   1.0.0
 * @author    Sam Rankin <srankin@riester.com>
 * @copyright 2022 RIESTER
 * ========================================================================== */
import { getCookie, setCookie, get, changeTag, listen } from '../../utils';

import choices from '../../vendors/choices';
const falsey = require('falsey');

export default {
	name: 'login',

	getLoginCookie() {
		var n = getCookie('Login');

		return !falsey(n) ? n : 'iMPB';
	},
	selectEl() {
		return choices(document.getElementById('login-select'), { choices: window.login.options });
	},
	/**
	 * Gets the form to display from the select element
	 *
	 * @returns string
	 */
	getSelectedForm() {
		var n = $('#login-select').find(':selected').data('login');

		return !falsey(n) ? n : 'imanage-personal';
	},

	initLoginWidget() {
		const ctx = this;
		let currentLogin = this.getLoginCookie();

		const loginSelect = choices(document.getElementById('login-select'), { choices: window.login.options });

		window.login.instance = loginSelect;

		if (!falsey(currentLogin) && !falsey(loginSelect)) {
			loginSelect.setChoiceByValue(currentLogin);

			let selected = loginSelect.getValue();

			ctx.loginSelectionChange(selected.value, selected.customProperties.login);
		} else {
			this.setLoginCookie('iMPB');
		}

		listen(document.getElementById('login-select'), 'change', () => {
			let selected = loginSelect.getValue();

			ctx.loginSelectionChange(selected.value, selected.customProperties.login);
		});

		ctx.setupLoginSubmissions();
	},

	loginSelectionChange(val, login) {
		this.setLoginCookie(val);
		this.loginSelectionDisplay(val, login);
	},
	loginSelectionDisplay(val, login) {
		let selected = login;

		let selectedForm = document.querySelector(`#login-module form[data-login="${selected}"]`),
			hiddenForms = document.querySelectorAll(`#login-module form:not([data-login="${selected}"])`),
			submitBtn = selectedForm.querySelector('.btn[data-action="login"]'),
			system = this.getLoginSystemByValue(val);

		selectedForm.classList.add('selected');
		selectedForm.querySelectorAll('input, a, button, select').forEach((input) => {
			input.removeAttribute('tabindex');
			input.removeAttribute('aria-disabled');
			input.removeAttribute('disabled');
		});
		if (!falsey(system)) {
			var btnUrl = get(system, 'Url');

			if (!falsey(btnUrl)) {
				submitBtn.setAttribute('href', btnUrl);
				submitBtn.setAttribute('target', '_blank');
				submitBtn.removeAttribute('type');
				changeTag(submitBtn, 'a');
			} else {
				submitBtn.removeAttribute('href', btnUrl);
				submitBtn.setAttribute('type', 'submit');
				submitBtn.removeAttribute('target');
				changeTag(submitBtn, 'button');
			}
		}

		Array.from(hiddenForms).forEach((form) => {
			form.classList.remove('selected');

			form.querySelectorAll('input, a, button, select').forEach((input) => {
				input.setAttribute('tabindex', '-1');
				input.setAttribute('aria-disabled', 'true');
				input.disabled = true;
			});
		});
	},
	setLoginCookie(n) {
		setCookie('Login', n, {
			weeks: 1,
		});
	},

	getLoginSystemByValue(n) {
		if (falsey(n)) {
			return null;
		}

		let loginSystem = window.login.systems.filter((i) => {
			return n === i.Code;
		});

		if (!falsey(loginSystem)) {
			loginSystem = loginSystem[0];
		}

		return loginSystem;
	},

	setupLoginSubmissions() {},

	resize() {},
	init() {},
	finalize() {
		this.initLoginWidget();
	},
};
